import { Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Title } from "@angular/platform-browser";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";

import { ApiService } from "./api.service";
declare const BrandVars;
declare const gtag: (command: string, targetId: string, config?: Record<string, unknown>) => void;

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
	imports: [RouterOutlet]
})
export class AppComponent {
	private title = inject(Title);
	private api = inject(ApiService);
	router = inject(Router);

	constructor() {
		this.api.LoadTokenIfPossible();
		this.title.setTitle(BrandVars.appName);
		// Kick off a GA update (if available) after route change
		this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
			if (BrandVars.analyticsId && event instanceof NavigationEnd) {
				gtag('config', BrandVars.analyticsId,
					{
						'page_path': event.urlAfterRedirects
					}
				);
			}
		});
	}
}
